/**
 * Serializa los importes del borrador como decimales canónicos para el contrato
 * Cosmos. El estado visual todavía usa `number`, pero ningún request de borrador
 * entrega esos números directamente a JSON: así `29.30` llega como `"29.30"`.
 */
export function canonicalDecimal(value: number, fractionDigits: number): string {
  if (!Number.isFinite(value)) return '0'
  return value.toFixed(fractionDigits)
}

/**
 * Serializa `tipoCambio` respetando la regla CFDI40114 del SAT: cuando la moneda es MXN el
 * valor debe ser exactamente `1`.
 *
 * El PAC compara ese campo de forma **literal**, no numérica: `"1.000000"` es un `t_Importe`
 * válido según el XSD y aun así lo rechaza con `ValorEsperado: 1 ValorReportado: 1.000000`.
 * Para el resto de monedas se conservan los 6 decimales del Anexo 20, donde el tipo de cambio
 * sí es una conversión real.
 *
 * Espejo de `formatTipoCambio` en abakoo-timbra y de `CanonicalTipoCambio` en abakoo-api — los
 * tres normalizan la misma regla en su propia capa.
 */
export function canonicalTipoCambio(moneda: string, value: number | null): string | null {
  if (value === null) return null
  if (moneda.trim().toUpperCase() === 'MXN') return '1'
  return canonicalDecimal(value, 6)
}
